/**
 * ResponsavelHistoricoSmsCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {ResponsavelHistoricoSms} from '@/model/resource/ResponsavelHistoricoSms'

/* TODO: review generated class */
@HttpExclude()
export class ResponsavelHistoricoSmsCollection extends PageCollection<
  ResponsavelHistoricoSms
> {
  constructor() {
    super(ResponsavelHistoricoSms)
  }

  queryAsPage() {
    return this.listResponsavelHistoricoSms()
  }

  async listResponsavelHistoricoSms() {
    return await Request.get(`/admin/responsavel-historico-sms`, {
      params: this.params,
    })
      .name('listResponsavelHistoricoSms')
      .as(this)
      .getResponse()
  }

  async listCsvResponsavelHistoricoSms() {
    return await Request.get(`/admin/responsavel-historico-sms/csv`, {
      params: this.params,
    })
      .name('listCsvResponsavelHistoricoSms')
      .as(this)
      .getResponse()
  }
}
